var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-card', {
    staticClass: "shadow-sm"
  }, [_c('b-card-title', {
    staticClass: "mb-4 pt-6 px-6 d-flex justify-content-between"
  }, [_c('div', [_c('b-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "cart-fill",
      "variant": "primary"
    }
  }), _c('span', [_vm._v("Relação de Vendas")])], 1), _c('FiltroComparativo', {
    staticClass: "mt-1",
    attrs: {
      "auto-apply-on-mount": !_vm.ignoreInitialApply
    },
    on: {
      "change-comparacao": _vm.onChangeComparacao
    }
  })], 1), _c('b-card-body', {
    staticClass: "px-6 pb-6 pt-2"
  }, [_vm.loading ? [_c('ul', {
    staticClass: "list-unstyled m-0 p-0"
  }, _vm._l(5, function (i) {
    return _c('li', {
      key: i,
      staticClass: "d-flex align-items-center mb-6"
    }, [_c('div', {
      staticClass: "d-flex justify-content-center align-items-center rounded-circle mr-4",
      staticStyle: {
        "width": "36px",
        "height": "36px",
        "background-color": "#f3f6f9"
      }
    }, [_c('b-skeleton', {
      attrs: {
        "width": "18px",
        "height": "18px"
      }
    })], 1), _c('div', {
      staticClass: "flex-grow-1",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between"
    }, [_c('b-skeleton', {
      attrs: {
        "width": "40%",
        "height": "16px"
      }
    }), _c('b-skeleton', {
      attrs: {
        "width": "20%",
        "height": "14px"
      }
    })], 1), _c('b-skeleton', {
      staticClass: "mt-2",
      attrs: {
        "height": "8px"
      }
    })], 1)]);
  }), 0)] : [_c('apexchart', {
    key: _vm.chartKey,
    attrs: {
      "height": "280",
      "options": _vm.chartOptions,
      "series": _vm.chartSeries
    }
  }), !_vm.chartSeries.length ? _c('div', {
    staticClass: "text-center py-3"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Sem dados para o período selecionado")])]) : _vm._e()]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };